import Layout from "../../../components/shared/layout/layout";
import styles from "../../../styles/pages/weinkauf/shop/kassa.module.css"
import {deleteCookie, getCookies} from "cookies-next";
import {useEffect, useState} from "react";
import Link from "next/link";
import {useRouter} from "next/router";
import Seo from "../../../components/shared/seo/seo";

// Two cookie families end up in the cart:
//   cart-product-<productId>    one per vintage (existing flow)
//   cart-package-<headerId>     one per package (added with the package UX)
// This helper recognises both so the cart logic stays in one place.
function isCartCookie(name) {
    return name.startsWith("cart-product-") || name.startsWith("cart-package-");
}

function clearCookies() {
    let cookies = getCookies();

    for (const cookie in cookies) {
        if (isCartCookie(cookie)) {
            deleteCookie(cookie);
        }
    }
}

export default function Kassa(){
    const router = useRouter();
    const [products, setProducts] = useState(null);
    const [total, setTotal] = useState(0.0);
    const [totalTax10, setTotalTax10] = useState(0.0);
    const [totalTax13, setTotalTax13] = useState(0.0);
    const [totalTax20, setTotalTax20] = useState(0.0);
    const [totalTax19, setTotalTax19] = useState(0.0);
    const [shipping, setShipping] = useState(0.0);
    const [validDelivery, setValidDelivery] = useState(true);
    const [isCash, setIsCash] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);

    const [salutation, setSalutation] = useState(0);
    const [name, setName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [companyName, setCompanyName] = useState("");

    const [nameDelivery, setNameDelivery] = useState("");
    const [firstNameDelivery, setFirstNameDelivery] = useState("");
    const [companyNameDelivery, setCompanyNameDelivery] = useState("");

    const [invoiceStreet, setInvoiceStreet] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [invoiceAddressExtra, setInvoiceAddressExtra] = useState("");
    const [deliveryAddressExtra, setDeliveryAddressExtra] = useState("");
    const [invoiceZipCode, setInvoiceZipCode] = useState("");
    const [invoiceCity, setInvoiceCity] = useState("");
    const [invoiceCountry, setInvoiceCountry] = useState(1);
    const [deliveryStreet, setDeliveryStreet] = useState("");
    const [deliveryNumber, setDeliveryNumber] = useState("");
    const [deliveryZipCode, setDeliveryZipCode] = useState("");
    const [deliveryCity, setDeliveryCity] = useState("");
    const [message, setMessage] = useState("");
    const [deliveryCountry, setDeliveryCountry] = useState(1);
    const [invoiceIsDelivery, setInvoiceIsDelivery] = useState(true);
    const [phone, setPhone] = useState("");
    const [phoneDelivery, setPhoneDelivery] = useState("");
    const [mail, setMail] = useState("");
    const [mailDelivery, setMailDelivery] = useState("");
    const [mailConfirm, setMailConfirm] = useState("");
    const [mailDeliveryConfirm, setMailDeliveryConfirm] = useState("");
    const [deliveryType, setDeliveryType] = useState(0);
    const [pickupDate, setPickupDate] = useState(Date.now());
    const [newsletter, setNewsletter] = useState(false);
    const [privacy, setPrivacy] = useState(false);
    const [age, setAge] = useState(false);
    const [error, setError] = useState("");

    function showLoading(isLoading){
        if(isLoading)
            document.getElementById("loading")?.classList.add(styles.active);
        else{
            document.getElementById("loading")?.classList.remove(styles.active);
        }

    }

    function getDeliveryCosts(quantity){
            fetch(`https://api.gisperg.wine/api/Delivery/GetCosts?quantity=${quantity}&countryId=${deliveryCountry}`, {
                method: "GET",
                mode:"cors",
            }).then((res) => res.status == 200 && res.json()).then((data) => setShipping(data.number));
    }

    async function checkDelivery(quantity){
        try{
            let res = await fetch(`https://api.gisperg.wine/api/Delivery/ValidDelivery?quantity=${quantity}`, {
                method: "GET",
                mode:"cors",
            });
            if(res.status === 200) {
                var json = await res.json();
                if(!json){
                    setError("Die Bestellmenge muss ein Vielfaches von 6 betragen. (Magnum Flaschen zählen aus Verpackungsgründen aufgrund ihrer Größe als 2 Flaschen)");
                    setValidDelivery(false);
                }else{
                    setError("");
                    setValidDelivery(true);
                }

            }else{
                setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
            }
            return res.status;
        } catch(err){
            
            setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
        }
    }

    async function sendOrder() {
        checkDelivery(totalQuantity);

        if(!validDelivery){
            return;
        }

        if(!checkRequired()) {
            setError("Bitte alle Felder ausfüllen!");
            return;
        }

        if(!checkMail()){
            setError("Die Mail-Adressen stimmen nicht überein!");
            return;
        }
        if(!checkMandatoryBoxes()){
            setError("Bitte stellen Sie sicher, dass sie unseren Bestimmungen zustimmen und Sie älter als 16 Jahre sind!");
            return;
        }
        showLoading(true);

        let invoiceAddress = {
            street: invoiceStreet,
            houseNumber: invoiceNumber,
            additive:invoiceAddressExtra,
            zipCode : invoiceZipCode,
            city : invoiceCity,
            countryId:invoiceCountry
        }
        
        let deliveryAddress;
        if(invoiceIsDelivery){
            deliveryAddress = invoiceAddress;
        }else{
            deliveryAddress = {
                street: deliveryStreet,
                houseNumber: deliveryNumber,
                additive: deliveryAddressExtra,
                zipCode : deliveryZipCode,
                city : deliveryCity,
                countryId:deliveryCountry
            }
        }
        try{
            let res = await fetch(`https://api.gisperg.wine/api/Order/SaveOrder`, {
                headers:{'Content-Type' : 'application/json'},
                method: "POST",
                mode:"cors",
                body: JSON.stringify({
                    salutation: salutation,
                    name:name,
                    nameDelivery:nameDelivery,
                    firstName:firstName,
                    firstNameDelivery:firstNameDelivery,
                    companyName:companyName,
                    companyNameDelivery:companyNameDelivery,
                    invoiceAddress: invoiceAddress,
                    deliveryAddress:deliveryAddress,
                    invoiceAddressIsDeliveryAddress : invoiceIsDelivery,
                    phone:phone,
                    phoneDelivery:phoneDelivery,
                    mail:mail,
                    mailDelivery:mailDelivery,
                    deliveryType:deliveryType,
                    pickupDate:new Date(pickupDate).toISOString(),
                    cartItems: getCartIds(),
                    newsletter:newsletter,
                    message:message,
                    payWithCash:isCash
                }),
            });
            if(res.status == 200) {
                showLoading(false);
                resetFields();
                clearCookies(),
                await router.push("/weinkauf/shop");
            }else{
                showLoading(false);
                setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
            }
            return res.status;
        } catch(err){
            showLoading(false);
            
            setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
        }
    }

    function checkRequired(){
        if(name === "") return false;
        if(firstName === "") return false;
        if(invoiceStreet === "") return false;
        if(invoiceNumber === "") return false;
        if(invoiceZipCode === "") return false;
        if(invoiceCity === "") return false;
        if(mail === "") return false;
        if(!invoiceIsDelivery && deliveryStreet === "") return false;
        if(!invoiceIsDelivery && deliveryNumber === "") return false;
        if(!invoiceIsDelivery && deliveryZipCode === "") return false;
        if(!invoiceIsDelivery && deliveryCity === "") return false;
        if(!invoiceIsDelivery && nameDelivery === "") return false;
        if(!invoiceIsDelivery && firstNameDelivery === "") return false;
        return true;
    }
    function checkMandatoryBoxes(){
        
        
        if(!privacy) return false;
        if(!age) return false;
        return true;
    }
    function checkMail(){
        if(mail !== mailConfirm) return false;
        if(mailDelivery !== mailDeliveryConfirm) return false;
        return true;
    }
    function resetFields(){
        setName("");
        setNameDelivery("");
        setFirstName("");
        setFirstNameDelivery("");
        setCompanyName("");
        setCompanyNameDelivery("");
        setInvoiceAddressExtra("");
        setDeliveryAddressExtra("");
        setInvoiceStreet("");
        setInvoiceCountry(1);
        setInvoiceNumber("");
        setInvoiceZipCode("");
        setInvoiceCity("");
        setDeliveryStreet("");
        setDeliveryCountry(1);
        setDeliveryType(0);
        setDeliveryNumber("");
        setDeliveryZipCode("");
        setDeliveryCity("");
        setPhone("");
        setPhoneDelivery("");
        setAge(false);
        setPrivacy(false);
        setMail("");
        setMailDelivery("");
        setMailDeliveryConfirm("")
        setMailConfirm("");
        setInvoiceCity("")
    }


    async function removeCookieProduct(key) {
        deleteCookie(key);
        await initProducts();
    }
    useEffect(() => {
        initProducts();
    }, [deliveryCountry]);

    function getCartIds(){
        const ids=[];
        let cookies = getCookies();
        for (const cookie in cookies) {
            if(!isCartCookie(cookie)) continue;
            let entry = JSON.parse(decodeURIComponent(cookies[cookie]));
            // Packages explode into one entry per contained wine so the
            // backend's CartItem schema (which references vintages, not
            // packages) receives shippable units. Quantities are
            // multiplied by how many copies of the package the customer
            // bought.
            if (entry.kind === 'package' && Array.isArray(entry.contents)) {
                for (const c of entry.contents) {
                    ids.push({
                        productId: c.productId,
                        quantity: c.quantity * entry.count,
                    });
                }
            } else {
                ids.push({productId: entry.id, quantity: entry.count});
            }
        }
        return ids;
    }

     async function getProductById(id){
        return await fetch(`https://api.gisperg.wine/api/Product/${id}`,{
            method:'GET',
            mode: 'cors'
        }).then((res)=> res.json());
    }

    function getPriceForCountry(countryId, product){
        let price = product.prices.find((price) => price.countryId == countryId).value;
        return price;
    }

    async function initProducts() {
        const rows = [];
        let total = 0.0;
        let totalTax20 = 0.0;
        let totalTax10 = 0.0;
        let totalTax13 = 0.0;
        let totalTax19 = 0.0;
        let quantity = 0;
        let cookies = getCookies();
        for (const cookie in cookies) {
            if(!isCartCookie(cookie)) continue;
            let productCookie = JSON.parse(decodeURIComponent(cookies[cookie]));

            // Packages have no /api/Product/{id} record — the cookie
            // already carries everything needed (price, takesSpace,
            // taxRate, name). Render directly and skip the fetch.
            if (productCookie.kind === 'package') {
                const price = productCookie.price ?? 0;
                total += productCookie.count * price;
                if (productCookie.taxRate == 13.0)
                    totalTax13 += ((productCookie.count * price) * 13) / 113;
                if (productCookie.taxRate == 20.0)
                    totalTax20 += ((productCookie.count * price) * 20) / 120;
                if (productCookie.taxRate == 10.0)
                    totalTax10 += ((productCookie.count * price) * 10) / 110;
                if (deliveryCountry == 2) {
                    totalTax19 += ((productCookie.count * price) * 19) / 119;
                    totalTax13 = 0;
                    totalTax10 = 0;
                    totalTax20 = 0;
                }
                quantity += productCookie.count * (productCookie.takesSpace ?? 0);
                rows.push(
                    <div key={cookie} id={cookie} style={{width:"100%"}}>
                        <div className="column start left" style={{marginBottom:0}}>
                            <p className="left mobile" style={{margin:0}}>{productCookie.count} x </p>
                            <p className="col-6 left mobile" style={{margin:0}}>{productCookie.name}</p>
                            <p className="col-3 right mobile" style={{margin:0}}>{(Math.round(price * productCookie.count * 100) / 100).toFixed(2)} €</p>
                        </div>
                        <p className="annotation underline size-12" style={{cursor:"pointer", marginTop:0}} onClick={() => removeCookieProduct(cookie)}>entfernen</p>
                    </div>
                );
                continue;
            }
            await getProductById(productCookie.id).then((product) => {
                    let price = getPriceForCountry(deliveryCountry, product);
                    total += (productCookie.count * price);
                    
                    if(productCookie.taxRate == 13.0)
                        totalTax13 += ((productCookie.count * price) *13) / 113;
                    if(productCookie.taxRate == 20.0)
                        totalTax20 += ((productCookie.count * price) *20) / 120;
                    if(productCookie.taxRate == 10.0)
                        totalTax10 += ((productCookie.count * price) *10) / 110;
                    if(deliveryCountry == 2){
                        totalTax19 += ((productCookie.count * price) *19) / 119;
                        totalTax13 = 0;
                        totalTax10 = 0;
                        totalTax20 = 0;
                    }
                    quantity += productCookie.count * product.takesSpace;

                    return rows.push(
                        <div key={`cart-product-${product.id}`} id={`cart-product-${product.id}`} style={{width:"100%"}}>
                            <div className="column start left" style={{marginBottom:0}}>
                                <p className="left mobile" style={{margin:0}}>{productCookie.count} x </p>
                                <p className="col-6 left mobile" style={{margin:0}}>{productCookie.name} {product.capacity}</p>
                                <p className="col-3 right mobile" style={{margin:0}}>{(Math.round( price * productCookie.count * 100)/ 100).toFixed(2)} €</p>
                            </div>
                            <p className="annotation underline size-12" style={{cursor:"pointer", marginTop:0}} onClick={() => removeCookieProduct(`cart-product-${productCookie.id}`)}>entfernen</p>
                        </div>);
                });
        }
        setProducts(rows);
        setTotal(total);
        setTotalTax10(totalTax10);
        setTotalTax13(totalTax13);
        setTotalTax20(totalTax20);
        setTotalTax19(totalTax19);
        getDeliveryCosts(quantity);
        checkDelivery(quantity);
        setTotalQuantity(quantity);
    }

    return (
        <Layout>
            <Seo title="Kassa" description="Bestellung abschließen — Weingut Gisperg." path="/weinkauf/shop/kassa" />
            <div id="loading" className={styles.loading}>
                <div className={styles.ldsHeart}>
                    <div></div>
                </div>
                <p className="annotation white">Bestellung wird gesendet...</p>
            </div>
            <section className="background_light_texture small no_fill">
                <h1>Kassa</h1>
            </section>
            <section className="background_lighter">
                <div className="horizontal">
                    <div className="col-6 start left fields">
                        <h2>Rechnungsdetails</h2>
                        <div className="column vertical-center">
                            <span className="narrow size-16 start left">Anrede:*</span>
                            <fieldset className="column vertical-center" style={{border: 0}}>
                                <div>
                                    <input type="radio" style={{marginRight: "1rem", accentColor: "black"}}
                                           id="salutation_mr" name="salutation" value={0}
                                           defaultChecked={salutation == 0} onClick={(e) => setSalutation(0)}/>
                                    <label className="narrow" htmlFor="salutation_mr">Herr</label>
                                </div>
                                <div>
                                    <input type="radio" style={{marginRight: "1rem", accentColor: "black"}}
                                           id="salutation_mrs" name="salutation" value={1}
                                           defaultChecked={salutation == 1} onClick={(e) => setSalutation(1)}/>
                                    <label className="narrow" htmlFor="salutation_mrs">Frau</label>
                                </div>
                                <div>
                                    <input type="radio" style={{marginRight: "1rem", accentColor: "black"}}
                                           id="salutation_div" name="salutation" value={2}
                                           defaultChecked={salutation == 2} onClick={(e) => setSalutation(2)}/>
                                    <label className="narrow" htmlFor="salutation_div">Divers</label>
                                </div>
                            </fieldset>
                        </div>
                        <div className="column">
                            <div className="input col-6">
                                <input type="text" id="first_name" placeholder="Vorname*" value={firstName}
                                       onChange={(e) => setFirstName(e.target.value)}/>
                            </div>
                            <div className="input col-6">
                                <input type="text" id="last_name" placeholder="Nachname*" value={name}
                                       onChange={(e) => setName(e.target.value)}/>
                            </div>
                        </div>
                        <div className="input fillWidth">
                            <input type="text" id="company_name" placeholder="Unternehmensbezeichnung (optional)"
                                   value={companyName} onChange={(e) => setCompanyName(e.target.value)}/>
                        </div>
                        <div className="input fillWidth">
                            <select name="countries" id="country" value={invoiceCountry} onChange={async (e) => {
                                
                                setInvoiceCountry(e.target.value);
                                if (invoiceIsDelivery)
                                    setDeliveryCountry(e.target.value);
                                
                            }}>
                                <option value="1">Österreich</option>
                                <option value="2">Deutschland</option>
                            </select>
                        </div>

                        <div className="column">
                            <div className="input col-8">
                                <input type="text" id="street" placeholder="Straße*" value={invoiceStreet}
                                       onChange={(e) => setInvoiceStreet(e.target.value)}/>
                            </div>
                            <div className="input col-4">
                                <input type="text" id="number" placeholder="Nr.*" value={invoiceNumber}
                                       onChange={(e) => setInvoiceNumber(e.target.value)}/>
                            </div>
                        </div>
                        <div className="column">
                            <div className="input col-12">
                                <input type="text" id="addressExtra" placeholder="Adresszusatz (optional)"
                                       value={invoiceAddressExtra}
                                       onChange={(e) => setInvoiceAddressExtra(e.target.value)}/>
                            </div>
                        </div>
                        <div className="column">
                            <div className="input col-4">
                                <input type="text" id="zipcode" placeholder="PLZ*" value={invoiceZipCode}
                                       onChange={(e) => setInvoiceZipCode(e.target.value)}/>
                            </div>
                            <div className="input col-8">
                                <input type="text" id="city" placeholder="Ort/Stadt*" value={invoiceCity}
                                       onChange={(e) => setInvoiceCity(e.target.value)}/>
                            </div>
                        </div>
                        <div className="input fillWidth">
                            <input type="text" id="phone" placeholder="Telefon (optional)" value={phone}
                                   onChange={(e) => setPhone(e.target.value)}/>
                        </div>
                        <div className="column">
                            <div className="input col-6">
                                <input type="text" id="email" placeholder="E-Mail*" value={mail}
                                       onChange={(e) => setMail(e.target.value)}/>
                            </div>
                            <div className="input col-6">
                                <input type="text" id="confirmMail" placeholder="E-Mail bestätigen*" value={mailConfirm}
                                       onChange={(e) => setMailConfirm(e.target.value)}/>
                            </div>
                        </div>
                        <h2>Lieferdetails</h2>
                        <div>
                            <input type="checkbox" id="deliver_is_invoice"
                                   style={{marginRight: "1rem", accentColor: "black"}} checked={!invoiceIsDelivery}
                                   onChange={async () => {
                                       setInvoiceIsDelivery(!invoiceIsDelivery);
                                       setDeliveryCountry(invoiceCountry);
                                   }}/>
                            <label className="narrow" htmlFor="deliver_is_invoice">Die Lieferadresse weicht von der
                                Rechnungsadresse ab</label>
                        </div>
                        <div className={`${styles.deliveryDiffers} ${invoiceIsDelivery && "no_display"}`}>
                            <div className="column">
                                <div className="input col-6">
                                    <input type="text" id="first_name" placeholder="Vorname*" value={firstNameDelivery}
                                           onChange={(e) => setFirstNameDelivery(e.target.value)}/>
                                </div>
                                <div className="input col-6">
                                    <input type="text" id="last_name" placeholder="Nachname*" value={nameDelivery}
                                           onChange={(e) => setNameDelivery(e.target.value)}/>
                                </div>
                            </div>
                            <div className="input fillWidth">
                                <input type="text" id="company_name" placeholder="Unternehmensbezeichnung (optional)"
                                       value={companyNameDelivery}
                                       onChange={(e) => setCompanyNameDelivery(e.target.value)}/>
                            </div>
                            <div className="input fillWidth">
                                <select name="countries" id="country" value={deliveryCountry} onChange={async (e) => {
                                    if (!invoiceIsDelivery) {
                                        setDeliveryCountry(e.target.value);
                                    }
                                }}>
                                    <option value="1">Österreich</option>
                                    <option value="2">Deutschland</option>
                                </select>
                            </div>
                            <div className="column">
                                <div className="input col-8">
                                    <input type="text" id="street" placeholder="Straße*" value={deliveryStreet}
                                           onChange={(e) => setDeliveryStreet(e.target.value)}/>
                                </div>
                                <div className="input col-4">
                                    <input type="text" id="number" placeholder="Nr.*" value={deliveryNumber}
                                           onChange={(e) => setDeliveryNumber(e.target.value)}/>
                                </div>
                            </div>
                            <div className="column">
                                <div className="input col-12">
                                    <input type="text" id="addressExtraDelivery" placeholder="Addresszusatz (optional)"
                                           value={deliveryAddressExtra}
                                           onChange={(e) => setDeliveryAddressExtra(e.target.value)}/>
                                </div>
                            </div>
                            <div className="column">
                                <div className="input col-4">
                                    <input type="text" id="zipcode" placeholder="PLZ*" value={deliveryZipCode}
                                           onChange={(e) => setDeliveryZipCode(e.target.value)}/>
                                </div>
                                <div className="input col-8">
                                    <input type="text" id="city" placeholder="Ort/Stadt*" value={deliveryCity}
                                           onChange={(e) => setDeliveryCity(e.target.value)}/>
                                </div>
                            </div>
                            <div className="input fillWidth">
                                <input type="text" id="phone" placeholder="Telefon (Zustell-Information)" value={phoneDelivery}
                                       onChange={(e) => setPhoneDelivery(e.target.value)}/>
                            </div>
                            <div className="column">
                                <div className="input col-6">
                                    <input type="text" id="email" placeholder="E-Mail (Zustell-Information)" value={mailDelivery}
                                           onChange={(e) => setMailDelivery(e.target.value)}/>
                                </div>
                                <div className="input col-6">
                                    <input type="text" id="confirmMail" placeholder="E-Mail bestätigen"
                                           value={mailDeliveryConfirm}
                                           onChange={(e) => setMailDeliveryConfirm(e.target.value)}/>
                                </div>
                            </div>
                        </div>
                        <h2>Anmerkung</h2>
                        <div className="column">
                            <textarea
                                placeholder="Sie möchten uns noch etwas mitteilen? Hinterlassen Sie Ihre Nachricht hier."
                                style={{width: "100%", height: "200px", padding: "15px"}} value={message}
                                onChange={(e) => setMessage(e.target.value)}/>
                        </div>
                    </div>
                    <div className="col-6 start left">
                        <h2>Lieferung</h2>
                        <fieldset className="vertical-center" style={{border: 0}}>
                            <div>
                                <input type="radio" style={{marginRight: "1rem", accentColor: "black"}}
                                       id="delivery_delivery" name="delivery" value={0}
                                       defaultChecked={deliveryType == 0} onClick={(e) => setDeliveryType(0)}/>
                                <label className="narrow" htmlFor="newsletter_mail">Lieferung</label>
                            </div>
                            <div>
                                <input type="radio" style={{marginRight: "1rem", accentColor: "black"}}
                                       id="delivery_pickup" name="delivery" value={1} defaultChecked={deliveryType == 1}
                                       onClick={(e) => setDeliveryType(1)}/>
                                <label className="narrow" htmlFor="newsletter_mail">Abholung</label>
                            </div>
                        </fieldset>
                        <div className={`col-12 ${deliveryType === 0 && "no_display"}`} style={{marginBottom: "0"}}>
                            <p className="narrow size-14">Abholungen sind nur während unserer Öffnungszeiten Mo-Fr
                                8-12/13-18 Uhr und Samstags auf Anfrage möglich.</p>
                        </div>
                        <div className={`input col-12 ${deliveryType === 0 && "no_display"}`}>
                            <label className="narrow" htmlFor="pickupTime"
                                   style={{marginRight: "1rem", accentColor: "black"}}>Abholzeitpunkt:*</label>
                            <input type="datetime-local" id="pickupTime" value={pickupDate}
                                   onChange={(e) => setPickupDate(e.target.value)}/>
                        </div>
                        <div className={`col-12 ${deliveryType === 0 && "no_display"}`}>
                            <p className="narrow size-14"> Wenn Sie Leergut retourieren möchten, geben Sie uns bitte die
                                Stückzahl im Anmerkungsfeld bekannt!</p>
                        </div>
                        <h2>Zahlungsart</h2>
                        <div className={`${deliveryType === 1 && "no_display"}`}>
                            <input type="radio" id="deliver_is_invoice"
                                   style={{marginRight: "1rem", accentColor: "black"}} defaultChecked/>
                            <label className="narrow" htmlFor="deliver_is_invoice">Rechnung</label>
                            <p className="">Sie erhalten nach der Bestellung eine Rechnung von uns. Bitte überweisen Sie
                                den Gesamtbetrag bei Rechnungserhalt ohne Abzüge auf das dort angegebene Konto.</p>
                        </div>
                        <div className={`${deliveryType === 0 && "no_display"}`}>
                            <input type="radio" id="deliver_is_cash"
                                   style={{marginRight: "1rem", accentColor: "black"}} checked={isCash} defaultChecked
                                   onClick={(e) => setIsCash(true)}/>
                            <label className="narrow" htmlFor="deliver_is_cash">Bar</label><br/>
                            <input type="radio" id="deliver_is_card" checked={!isCash} onClick={(e) => setIsCash(false)}
                                   style={{marginRight: "1rem", accentColor: "black"}}/>
                            <label className="narrow" htmlFor="deliver_is_card">Bankomat</label>
                        </div>
                        <h2>Zusammenfassung</h2>
                        {products != null && products}
                        <div className="column">
                            <p className="size-20" style={{margin: 0}}>Zwischensumme</p>
                            <p className="size-20"
                               style={{margin: 0}}>{(Math.round(total * 100) / 100).toFixed(2)} €</p>
                        </div>
                        <div className="column">
                            <p className="size-20" style={{margin: 0}}>Versand</p>
                            <p className="size-20"
                               style={{margin: 0}}>{(Math.round(shipping * 100) / 100).toFixed(2)} €</p>
                        </div>
                        <div className="column">
                            <p className="size-20 gotham-bold" style={{margin: 0}}>Gesamt</p>
                            <p className="size-20 gotham-bold"
                               style={{margin: 0}}>{(Math.round((total + shipping) * 100) / 100).toFixed(2)} €</p>
                        </div>
                        <div className={`column ${totalTax10 == 0.0 && "hidden"}`}>
                            <p className="size-14" style={{margin: 0}}>inkl. 10 % MwSt.</p>
                            <p className="size-14"
                               style={{margin: 0}}>{(Math.round((totalTax10 * 100) / 100)).toFixed(2)} €</p>
                        </div>
                        <div className={`column ${deliveryCountry == 2 && "hidden"}`}>
                            <p className="size-14" style={{margin: 0}}>inkl. 13 % MwSt.</p>
                            <p className="size-14"
                               style={{margin: 0}}>{(Math.round((totalTax13 + ((shipping * 13) / 113)) * 100) / 100).toFixed(2)} €</p>
                        </div>
                        <div className={`column ${totalTax20 == 0.0 && "hidden"}`}>
                            <p className="size-14" style={{margin: 0}}>inkl. 20 % MwSt.</p>
                            <p className="size-14"
                               style={{margin: 0}}>{(Math.round((totalTax20 * 100) / 100)).toFixed(2)} €</p>
                        </div>
                        <div className={`column ${totalTax19 == 0.0 && "hidden"}`}>
                            <p className="size-14" style={{margin: 0}}>inkl. 19 % MwSt.</p>
                            <p className="size-14"
                               style={{margin: 0}}>{(Math.round((totalTax13 + ((shipping * 19) / 119)) * 100) / 100).toFixed(2)} €</p>
                        </div>
                        <div style={{marginTop: "20px"}}>
                            <input type="checkbox" id="privacy" style={{marginRight: "1rem", accentColor: "black"}}
                                   defaultChecked={privacy} onClick={() => setPrivacy(!privacy)}/>
                            <label className="narrow size-14" htmlFor="privacy">Mit meiner Bestellung erkläre ich mich
                                mit den <Link href="/agb"><span className="underline size-12 link">Allgemeinen Geschäftsbedingungen</span></Link>, <Link
                                    href="/agb#wiederruf"><span
                                    className="underline size-12 link">Widerrufsbestimmungen</span></Link> und <Link
                                    href="/datenschutz"><span
                                    className="underline size-12 link">Datenschutzbestimmungen</span></Link> einverstanden.</label>
                        </div>
                        <div>
                            <input type="checkbox" id="age" style={{marginRight: "1rem", accentColor: "black"}}
                                   defaultChecked={age} onClick={() => setAge(!age)}/>
                            <label className="narrow size-14" htmlFor="age">Ich bestätige, dass ich mindestens 16 Jahre
                                alt bin.</label>
                        </div>
                        <div>
                            <input type="checkbox" id="newsletter" style={{marginRight: "1rem", accentColor: "black"}}
                                   value="pickup" defaultChecked={newsletter}
                                   onClick={() => setNewsletter(!newsletter)}/>
                            <label className="narrow size-14" htmlFor="newsletter">Ich möchte den Newsletter
                                abonnieren.</label>
                        </div>
                        <p className="button primary x2" onClick={() => sendOrder()}>Jetzt Kaufen</p>
                        {error != "" && <p style={{color: "red"}}>{error}</p>}
                    </div>
                </div>
            </section>
        </Layout>
    );
}